module.exports = __webpack_public_path__ + "static/media/social4.ead64f26.png";